import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/providers/apiService/api.service';

@Component({
  selector: 'app-doctors-list',
  templateUrl: './doctors-list.component.html',
  styleUrls: ['./doctors-list.component.scss'],
})
export class DoctorsListComponent implements OnInit {
  doctorList: any[];
  filterdoctorList = [];
  hasSkelton= true;
  filter: any;
  constructor( private apiService: ApiService,public modalController: ModalController) { }

  ngOnInit() {this.getdoctorList();}

  getdoctorList() {
    this.apiService.post('user/doctor-lists', {}).subscribe(
      (res) => {
        this.hasSkelton=false;
        if (res.error === false) {
          this.doctorList = res.data.doctors;
          this.filterdoctorList = this.doctorList;

        }else{
          this.hasSkelton=false;
        }
      },
      (err) => {
        this.hasSkelton=false;
      }
    );
  }
  goBack(){
    //console.log('go back');
    this.modalController.dismiss();
  }
  selectDoctor(doctor){
      this.modalController.dismiss(doctor);
  }

  searchDoctor(event: any): void {
    if (!event) {
        this.filterdoctorList = this.doctorList;
    }
    const newValue = event.target.value && event.target.value.trim().toLowerCase();
    if (!newValue || !this.doctorList) {
        this.filterdoctorList = this.doctorList;
    } else if (this.doctorList.length > 0 && typeof this.doctorList[0].Doctor.name != 'undefined') {
        this.filterdoctorList = this.doctorList.filter((doctor) => doctor.Doctor.name.toLowerCase().indexOf(newValue) > -1);
    }
}

}
